  <template>
    <v-dialog
        overlay-color="error"
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
        <v-card tile color="#F6F7FF">
        <v-toolbar
            shaped
            dense
            flat
            dark
            color="primary"
        >
            <v-btn
                icon
                dark
                @click="onClose"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Данные пространства</v-toolbar-title>
        </v-toolbar>
        
        <v-card-text v-if="workspace">
            <v-card-title>{{workspace.name}}</v-card-title>
            <v-row>
                <v-col cols="6">
                    <workspace-users :workspaceId="workspaceId"></workspace-users>
                </v-col>
                <v-col cols="6">
                    <workspace-organizations :workspaceId="workspaceId"></workspace-organizations>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text v-else>
            <h2 v-if="! isFetching">Не удалось загрузить пространство</h2>
        </v-card-text>
        </v-card>
        <v-overlay :value="isFetching">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>

<script>
import * as api from '@/api/admin/workspaces';
import WorkspaceUsers from './WorkspaceUsers';
import WorkspaceOrganizations from './WorkspaceOrganizations';
export default {
    components:{
        WorkspaceUsers, WorkspaceOrganizations
    },
    created () {
        this.load(this.workspaceId);
    },
    name: 'WorkspaceListDialog',
    props: {
      dialog: {
          type: Boolean,
          default: false
      },
      workspaceId: {
          type: Number,
          require: true
      }
    },
    data: () => ({
        isFetching: false,
        workspace: null,
    }),
    methods: {
        onClose(){
            this.$emit('update:dialog', false);
        },
        setFetchState(){
            this.isFetching = true;
            this.setWorkspace(null);
        },
        async load(workspaceId){
            try{
                this.setFetchState();
                let response = await api.show(workspaceId);
                this.setWorkspace(response.data.data);
            }catch(err){
                console.log(err);
            }finally{
                this.isFetching = false;
            }
        },
        setWorkspace(workspace){
            this.workspace = workspace;
        }
    },
    computed:{
    },
}
</script>